












import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from '@/design-system/constructs/JobTile/JobTileViewModel';

@Component
export default class JdsAvatar extends Vue {
    @Prop() user!: User;
    @Prop({ default: '#ffffff', type: String }) outlineColor!: string;

    get hasImage(): boolean {
        return !!this.user.avatar;
    }

    get initials(): string {
        if (!this.user.name) {
            return '';
        }
        return this.user.name.replace(/([^\p{L}\p{M}\p{Zs}\d\s])+/gu, '').split(' ').map(word => word[0]).join('');
    }

    get avatarStyles() {
        return {
            fontSize: this.initials.length > 2 ? '65%' : '100%',
            backgroundImage: this.hasImage ? `url(${this.user.avatar})` : '',
            outline: `3px solid ${this.outlineColor}`,
        };
    }
}
